var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_9349)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25923 5.25911C6.28452 4.23382 7.81099 3.84998 9.7501 3.84998H14.2501C16.1892 3.84998 17.7157 4.23382 18.741 5.25911C19.7663 6.2844 20.1501 7.81087 20.1501 9.74998V14.25C20.1501 16.1891 19.7663 17.7156 18.741 18.7408C17.7157 19.7661 16.1892 20.15 14.2501 20.15H9.7501C7.81099 20.15 6.28452 19.7661 5.25923 18.7408C4.23394 17.7156 3.8501 16.1891 3.8501 14.25V9.74998C3.8501 7.81087 4.23394 6.2844 5.25923 5.25911ZM6.17847 6.17834C5.81974 6.53707 5.5479 7.02382 5.37407 7.6825H8.74011V5.19399C7.5143 5.30952 6.70727 5.64954 6.17847 6.17834ZM10.0401 5.14998V7.6825H13.9601V5.14998H10.0401ZM18.6261 7.6825H15.2601V5.19399C16.4859 5.30952 17.2929 5.64954 17.8217 6.17834C18.1804 6.53707 18.4523 7.02382 18.6261 7.6825ZM5.1501 9.74998C5.1501 9.47844 5.15833 9.22293 5.17456 8.9825H18.8256C18.8419 9.22293 18.8501 9.47844 18.8501 9.74998V14.25C18.8501 16.0609 18.4839 17.1594 17.8217 17.8216C17.1595 18.4838 16.061 18.85 14.2501 18.85H9.7501C7.93921 18.85 6.84068 18.4838 6.17847 17.8216C5.51626 17.1594 5.1501 16.0609 5.1501 14.25V9.74998ZM10.9626 12.9374C10.9626 12.4988 11.1126 12.3594 11.1715 12.3254C11.2298 12.2917 11.4249 12.2317 11.8028 12.4504L13.3623 13.3502C13.7398 13.5688 13.7857 13.7682 13.7857 13.8374C13.7857 13.9067 13.7393 14.1063 13.3619 14.3249L11.8019 15.2249C11.424 15.4437 11.2298 15.3832 11.1715 15.3494C11.1126 15.3154 10.9626 15.1761 10.9626 14.7374V12.9374ZM10.5206 11.2001C11.1203 10.8533 11.8333 10.9661 12.4528 11.3246L13.2324 11.7744L14.0133 12.2249C14.633 12.5837 15.0857 13.1454 15.0857 13.8374C15.0857 14.5294 14.6321 15.0917 14.0124 15.4504L13.2324 15.9004L12.453 16.3501C11.8334 16.7087 11.1203 16.8216 10.5206 16.4748C9.9213 16.1282 9.6626 15.4538 9.6626 14.7374V12.9374C9.6626 12.2211 9.9213 11.5467 10.5206 11.2001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_9349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelIcon);
export default __webpack_public_path__ + "static/media/reelIcon.2c726d85.svg";
export { ForwardRef as ReactComponent };